exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pwd-notice-top-main {\n  position: absolute;\n  background: white;\n  top: 0.520833rem;\n  left: 50%;\n  transform: translateX(-50%);\n  background: white;\n  padding: 0.052083rem 0.104167rem;\n  width: max-content;\n  font-size: 0.09375rem;\n  border-radius: 0.026042rem;\n  color: #909399;\n}\n.pwd-notice-top-main .el-icon-info {\n  color: rgb(24, 68, 225);\n}\n.pwd-notice-top-main .important,\n.important {\n  color: rgb(24, 68, 225);\n}", ""]);

// exports
